import {useState, useEffect} from 'react';
import { JumboDdPopover, JumboIconButton } from 'themes/jumbo/@jumbo/components';
import {
  useJumboHeaderTheme,
  useJumboTheme,
} from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import { Scrollbars } from "react-custom-scrollbars";
import { Div } from 'themes/jumbo/@jumbo/shared';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import EventsEmitter from "events/EventsEmitter";
import { useHistory } from 'react-router-dom';
import { getCachedData } from "api/Cache";
import * as Utils from "services/UtilsService";
import { PendingTasks } from './components';
import Badge from '@mui/material/Badge';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { useSelector } from 'react-redux';
import { tss } from "tss-react";
import { trackEvent } from 'components/Tracking';

import {
  Button,
  CardActions,
  CardHeader,
  Divider,
  ThemeProvider,
  Tooltip
} from '@mui/material';


type PendingType = {
	project : string,
	id : string,
	tasks : any
}

const useStyles = tss.create({
	miniAndClosed: {
		transform: 'scale(0.8)',
		marginTop: '-10px'
	}
})

const NotificationsPopover = (props:any) => {
  
	const {category, path, miniAndClosed = false} = props;
	const history = useHistory()
	const { theme } = useJumboTheme();
	const { headerTheme } = useJumboHeaderTheme();
	
	const [showAlert, setShowAlert] = useState(true);
	//const [projects, setProjects] = useState<any>([]);
	const storeAuthData = useSelector((state: any) => state.auth);
    const { defaultProjects } = storeAuthData;
	const storeCachedData = useSelector((state: any) => state.cache);
	//const { data } = storeCachedData;
	const [allPendingList, setAllPendingList] = useState<PendingType[]>([])
	const [allIssuesList, setAllIssuesList] = useState<string[]>([])
	const [nbPendingTasks, setNbPendingTasks] = useState<any>([])
	const [count, setCount] = useState(0);
	const data = getCachedData();
    const { classes } = useStyles();
	

	useEffect(() => {
		const reload = (event:any) => {
			setCount(prev => prev + 1);
			if(event?.data?.state === 'COMPLETE' || event?.data?.state === 'ERROR')
				EventsEmitter.emit("reloadData", "");
		};

		EventsEmitter.on("signalr_update", reload);
		EventsEmitter.on("dataUpdate", reload);
		return () => {
			EventsEmitter.removeEventListener("signalr_update", reload);
			EventsEmitter.removeEventListener("dataUpdate", reload);
		};
	}, []);

	useEffect(() => {
		const projects = data["projects"];
		const entities = data["entities"];

		const newAllPendingList: PendingType[] = [];
		const newAllIssuesList: string[] = [];
		const newNbPendingTasks: string[] = [];

		Object.entries(entities).forEach(([id, entity], index) => {
			const pending = Utils.sortArrayByProp(
				Object.values(entity as { [key: string]: any}).filter((p: any) =>
					p.state === "PARTIAL" &&
					p.type === "FILE" &&
					p.name
				),
				"file_date"
			);

			pending.forEach((p:any)  => {
				!newNbPendingTasks.includes(p.ID) && !defaultProjects.includes(p.project) && newNbPendingTasks.push(p.ID);
			});

			const issue = Object.values(entity as { [key: string]: any }).filter((p: any) =>
				p.state === "ERROR" && p.name
			);

			issue.forEach(p => {
				!newAllIssuesList.includes(p.ID) && !defaultProjects.includes(p.project) && newAllIssuesList.push(p.ID);
			});

			if (projects[id] && pending.length > 0) {
				newAllPendingList.push({
					project: projects[id].name,
					id: `project=${index}`,
					tasks: pending
				});
			}
		});

		setAllPendingList(newAllPendingList);
		setAllIssuesList(newAllIssuesList);
		setNbPendingTasks(newNbPendingTasks);

		if (newAllPendingList.length > 0) {
			setShowAlert(true);
		}
	}, [data, count]);


  	// useEffect(() => {
		
	// 		const projects = data["projects"];
	// 		const entities = data["entities"];	
		
	// 		Object?.entries(entities).map((entry: any, index: number) => {
	// 			var id = entry[0];
	// 			var pending: any = Object.values(entry[1]).filter((p: any) => {

	// 				if(p.state === "PARTIAL" && p.type === "FILE" && p.name && !nbPendingTasks.includes(p.ID)){
	// 					nbPendingTasks.push(p.ID)
	// 				}
	// 				return p.state === "PARTIAL" && p.type === "FILE" && p.name;
	// 			});

				
	// 			const issue: any = Object.values(entry[1]).filter((p: any) => {
	// 				if(p.state === 'ERROR' && p.name && !allIssuesList.includes(p.ID)){
	// 					allIssuesList.push(p.ID)
	// 				}
	// 				return p.state === 'ERROR' && p.name;
	// 			});

	// 			pending = Utils.sortArrayByProp(pending, "file_date");
	// 			const newItem: PendingType = {
	// 				project: projects[id].name,
	// 				id: `project=${index}`,
	// 				tasks: pending, // Make sure `pending` matches TaskType[]
	// 			};

	// 			if (projects[id] && pending.length > 0 && !allPendingList.includes(newItem)) {
	// 				allPendingList.push(newItem)
	// 				setShowAlert(true)		
	// 			}
	// 		})

	// 		var reload = () => {
	// 			setCount(prev => prev + 1);
	// 		};

	// 		EventsEmitter.on("signalr_update", reload);
	// 		EventsEmitter.on("dataUpdate", reload);
	// 		return () => {
	// 			EventsEmitter.removeEventListener("signalr_update", reload);
	// 			EventsEmitter.removeEventListener("dataUpdate", reload);
	// 		};

		 
	// }, [data, allPendingList, allIssuesList, nbPendingTasks, count]);


	const viewAllHandle = () => {
		history.push("/pending");
	}

	if (!data.loaded) {
        return ''; //progress === 0 ? <CircularProgress /> : <CircularProgressWithLabel value={progress} />;
    }
	return (
		<div 
			style={{ display: showAlert ? 'block' : 'none' }}
			className={ miniAndClosed ? classes.miniAndClosed : ''}
		>
			<ThemeProvider theme={theme}>
			<JumboDdPopover
				hidePopup = {category === 'pending' || category === 'issues'}
				triggerButton={
				<ThemeProvider theme={headerTheme}>
					{
					category === "pending" ? 
						
							<Badge 
								onClick={(e) => {
									e.preventDefault(); 
									trackEvent("TopMenu", "Pending", "Open");
									history.push(path);
								}}

								badgeContent={nbPendingTasks.length} 
								sx={{ 
									'& .MuiBadge-badge': {
									minWidth: '17px',
									height: '17px',
									borderRadius: '50%',
									backgroundColor: 'rgb(243, 151, 17)',
									color:'#fff',
									padding: 0
									} 
								}}
								>
							</Badge>
						
					: 
					category === "issues" 
					?
					<Badge 
							onClick={(e) => {
								e.preventDefault(); 
								history.push(path);
							}}
							badgeContent={allIssuesList.length} 
							sx={{ 
								'& .MuiBadge-badge': {
								minWidth: '17px',
								height: '17px',
								borderRadius: '50%',
								backgroundColor: 'rgb(243, 151, 17)',
								color:'#fff',
								padding: 0
								} 
							}}
							>
						</Badge>
					:
					<JumboIconButton elevation={2}>
						<Badge 
							badgeContent={nbPendingTasks.length} 
							sx={{ 
								'& .MuiBadge-badge': {
								minWidth: '17px',
								height: '17px',
								borderRadius: '50%',
								backgroundColor: 'rgb(243, 151, 17)',
								color:'#fff',
								padding: 0
								} 
							}}
							>
							<Tooltip title="Pending Tasks" placement="bottom" arrow>
								<AccessTimeOutlinedIcon />
							</Tooltip>
						</Badge>
						
					</JumboIconButton>
				}
				</ThemeProvider>
				}
			>
				<Div sx={{ width: 850, maxWidth: '90%'}} >
				<CardHeader
					title={'Pending tasks'}
				/>
					<Box sx={{ minHeight: 352, minWidth: 250 }}>
						<SimpleTreeView>
							<Scrollbars
									autoHeight
									autoHeightMax={300}
									style={{ overflowX: "hidden", width: "100%," }}
								>
									{
										allPendingList.length > 0 ?
											allPendingList.map((item:any) => <PendingTasks key={item['id']} project={item['project']} id={item['id']} tasks={item['tasks']}/>)
										: 
										<div style={{width: '50px', margin: '100px auto'}}>No task</div>
									}
							</Scrollbars>
						</SimpleTreeView>
					</Box>
					<Divider />
					<CardActions sx={{ justifyContent: 'center' }} onClick={viewAllHandle}>
						<Button
							sx={{
								textTransform: 'none',
								fontWeight: 'normal',
								'&:hover': { bgcolor: 'transparent' },
							}}
							size={'small'}
							variant='text'
							endIcon={<ArrowForwardIcon />}
							disableRipple
							>
							View All
						</Button>
					</CardActions>
					</Div>
				</JumboDdPopover>
			</ThemeProvider>
		</div>
	);
};

export { NotificationsPopover };
